import IconExternalLink from '@mnd-frontend/icons/components/ExternalLink';
import { Link } from '@mnd-frontend/ui/publish/components';
import { GREY_400, PURPLE_700, SPACING_1, SPACING_2 } from '@mnd-frontend/ui/shared/tokens';
import styled from 'styled-components';

const BlueLink = styled(Link)<{ $withBorder?: boolean }>`
  color: ${PURPLE_700};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACING_2};

  &:hover,
  &:focus {
    color: ${PURPLE_700};
  }

  ${props =>
    props.$withBorder &&
    `
    border-bottom: 1px solid ${GREY_400};
    padding-bottom: ${SPACING_1};
  `};

  span {
    flex: 1 0 0px;
  }
`;

const ExternalLink = ({
  link,
  text,
  withBorder,
}: {
  link: string;
  text: string;
  withBorder?: boolean;
}) => (
  <BlueLink target="_blank" href={link} $withBorder={withBorder} tabIndex={0}>
    <span>{text}</span>
    <IconExternalLink tabIndex={-1} />
  </BlueLink>
);

export default ExternalLink;
